import CalendarActivitiesPicker from './CalendarActivitiesPicker/CalendarActivitiesPicker'
import CalendarActivitiesList from './CalendarActivitiesList/CalendarActivitiesList'
import { useState } from 'react'

const CalendarActivities = (props: any) => {
    const {
        loading,
        activities,
        currentDate,
        openActivity,
        setCurrentDate,
        calendarHeight,
        setCalendarHeight,
        userLanguage,
        onScroll,
        totalCalendarActivities
    } = props

    const [showFullCalendar, setShowFullCalendar] = useState(false)
    
    return (
        <div className="home-calendar-activities">
            <CalendarActivitiesPicker
                userLanguage={userLanguage}
                showFullCalendar={showFullCalendar}
                setShowFullCalendar={setShowFullCalendar}
                setCurrentDate={setCurrentDate}
                setCalendarHeight={setCalendarHeight}
            />
            <CalendarActivitiesList
                activities={activities}
                loading={loading}
                openActivity={openActivity}
                currentDate={currentDate}
                calendarHeight={calendarHeight}
                onScroll={onScroll}
                totalCalendarActivities={totalCalendarActivities}
                onScrollDown={() => setShowFullCalendar(false)}
            />
        </div>
    )
}

export default CalendarActivities
